import { motion } from "framer-motion";

export const ProjectMediaGallery = ({ project, label }) => {
  const secondaryMedia = project.gallery?.slice(1) ?? [];

  if (!secondaryMedia.length) return null;

  return (
    <section data-testid="project-media-gallery" className="pb-10 pt-2 md:pb-14">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <p className="mb-6 font-mono text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
          {label}
        </p>
        <div className="grid gap-4 md:grid-cols-2">
          {secondaryMedia.map((media, index) => (
            <motion.figure
              key={media.src}
              data-testid={`project-gallery-image-${index + 1}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="aspect-[16/10] overflow-hidden border border-white/10 bg-[#0A0A0E]"
            >
              <img
                src={media.src}
                alt={`${project.client} — ${index + 2}`}
                className="h-full w-full object-contain"
              />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};